function initDotsProgressBar(group) {
  function update() {
    var markers = Array.from(group.querySelectorAll('.scroll-marker:not([hidden])'));
    var activeIndex = markers.findIndex(function(m) { return m.getAttribute('aria-current') === 'true'; });
    group.style.setProperty('--total-markers', markers.length);
    if (markers.length > 1 && activeIndex >= 0) {
      group.style.setProperty('--progress', activeIndex / (markers.length - 1));
    } else {
      group.style.setProperty('--progress', 0);
    }
  }
  update();
  var observer = new MutationObserver(update);
  group.querySelectorAll('.scroll-marker').forEach(function(marker) {
    observer.observe(marker, { attributes: true, attributeFilter: ['aria-current', 'hidden'] });
  });
}

function initAxProductGallery() {
  document.querySelectorAll('.product-gallery__controls-floating .scroll-marker-group--dots').forEach(function(group) {
    if (group.dataset.progressInitialized) return;
    group.dataset.progressInitialized = 'true';
    initDotsProgressBar(group);
  });
}

document.addEventListener('DOMContentLoaded', initAxProductGallery);
document.addEventListener('shopify:section:load', initAxProductGallery);
